// extracted by mini-css-extract-plugin
module.exports = {"sectionStyle":"Section_sectionStyle__1jIzl","noPadding":"Section_noPadding__GV9y_"};